import { UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import { type AddressLinks } from '@/microfrontends/listing/shared/types/AddressLinks';

import { Link } from '@/packages/shared-ui/components/InteractiveTypography';
import { isLastListItem } from '@/packages/utils/array';
import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import styles from './CardAddressBlock.css';

type AddressBlockProps = {
  address: Array<AddressLinks>;
  track(): void;
};

export const CardAddressBlock: FC<AddressBlockProps> = ({ address, track }) => (
  <div className={styles['wrapper']} data-testid="card.address">
    {address.map((addressPart, index, addressParts) => {
      return (
        <UIText2 color="gray60_100" display="inline" key={`${addressPart.id}-${index}`}>
          <Link
            behaviour="hover_gray_to_primary"
            display="inline"
            href={addressPart.offersUrl}
            track={track}
            onClick={stopPropagation}
          >
            {`${addressPart.title}${isLastListItem(addressParts, index) ? '' : ',\u0020'}`}
          </Link>
        </UIText2>
      );
    })}
  </div>
);
